import React from 'react';
import type { RemainingCounter } from '../utils/counters';
import { formatNumber } from '../utils/format';
interface RemainingCountersProps {
  items: RemainingCounter[];
}

/** «Сколько ещё раз» — телесные единицы против абстрактных недель. */
export function RemainingCounters({
  items
}: RemainingCountersProps) {
  const gains = items.filter(item => item.tone !== 'loss');
  const losses = items.filter(item => item.tone === 'loss');
  return <div className="flex flex-wrap items-baseline gap-x-7 gap-y-2 sm:gap-x-9" data-id="element-96" data-mp="3gwdpcq78sb8w">
      <span className="text-muted text-[11px]" data-id="element-97" data-mp="3kwnxo9iibdqx">ещё успеет случиться</span>

      {gains.map(item => <span key={item.id} className="flex items-baseline gap-1.5" data-id="element-98" data-mp="3pxv5g8kngcxl">
          <span className="text-ink font-mono text-sm tabular-nums" data-id="element-99" data-mp="3uwohrxo79xw6">{formatNumber(item.value)}</span>
          <span className="text-muted text-[11px]" data-id="element-100" data-mp="1vkcdde9e1mjo">{item.label}</span>
        </span>)}

      {losses.map(item => <span key={item.id} className="text-muted flex items-baseline gap-1.5 text-[11px]" data-id="element-101" data-mp="20ixcfacwm06j">
          <span className="text-faint" data-id="element-102" data-mp="2zh9bjtnt8h3z">·</span>
          из них{' '}
          <span className="font-mono text-sm tabular-nums line-through decoration-1" data-id="element-103" data-mp="2uopycxt1bnzp">
            {formatNumber(item.value)}
          </span>
          {item.label}
        </span>)}
    </div>;
}